// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components----Illustration-module---container---1ayuw","attic":"src-components----Illustration-module---attic---34ikB","factory":"src-components----Illustration-module---factory---3PVrZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration.module.css
// module id = 126
// module chunks = 35783957827783 43201937662106